module.exports = __webpack_public_path__ + "img/timestudy-5.1e7282f2.png";